import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { Loading } from '../../components/Loading';
import { useLogtoSession } from './logto-session';

export function LogtoRequiredLayout() {
  const { isAuthenticated, isLoading, error, login } = useLogtoSession();

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !error) {
      login();
    }
  }, [error, isAuthenticated, isLoading, login]);

  if (isLoading || (!isAuthenticated && !error)) {
    return <Loading />;
  }

  if (error) {
    return (
      <div>
        <h1>Authentication Error</h1>
        <p>Error loading admin session: {error.message}</p>
      </div>
    );
  }

  return <Outlet />;
}
